import { render } from "./PostActions.vue?vue&type=template&id=f9d19a8e&scoped=true"
import script from "./PostActions.vue?vue&type=script&lang=js"
export * from "./PostActions.vue?vue&type=script&lang=js"

import "./PostActions.vue?vue&type=style&index=0&id=f9d19a8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d19a8e"]])

export default __exports__